// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 967 ? "AppDashboard" : chunkId) + "." + {"318":"94cae87a","967":"eb4d5ff5"}[chunkId] + ".chunk.css";
};